<div *ngFor="let onderneming of ondernemingen.controls; let i = index">

    <snelstart-ui-button (click)="this.showDialog()"
                         class="custom-input-150"
                         icon="plus"
                         type="secondary">Specificeer
    </snelstart-ui-button>

</div>


<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="xl"
                                title="Specificatie herinvesteringsreserve">
    <snelstart-ui-dialog-body>
        <div class="ps-2">
            <form [formGroup]="specBeginstandHIRFG">
                <div class="row">
                    <div class="col col-1">
                        <p>Bedrag volgens openingsbalans</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="col-auto custom-input-150 custom-readonly"
                                                          formControlName="waardeOpening"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>
                </div>
            </form>
            <form (change)="saveForm()" [formGroup]="ondernemingFG">
                <div formArrayName="ondernemingen">
                    <div *ngFor="let onderneming of ondernemingen.controls; let i = index"
                         [formGroupName]="i">
                        <div class="row">
                            <div class="col col-1">
                                <p>Bij: Dotatie</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  class="col-auto custom-input-150"
                                                                  formControlName="dotatieHIR"
                                                                  id="dotatieHIR"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: Onttrekking</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  class="col-auto custom-input-150"
                                                                  formControlName="vrijvalHIR"
                                                                  id="vrijvalHIR"
                                                                  prefix="€ -"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </form>
            <form [formGroup]="specBeginstandHIRFG">
                <div class="row">
                    <div class="col col-1">
                        <p>Bedrag volgens slotbalans</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="col-auto custom-input-150"
                                                          formControlName="waardeSlot"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>
                </div>
            </form>

            <div *ngIf="this.getTotaal() !== 0" class="row col-5 ">
                <snelstart-ui-alert class="pt-3 pb-2" type="info">
                    Een bedrag van € {{ this.getTotaal().valueOf() | number:'1.0-0' }} is nog niet gespecificeerd.
                </snelstart-ui-alert>
            </div>

            <div *ngIf="this.specBeginstandHIRFG.get('waardeOpening')?.value > 0">

                <hr class="line-color pt-2">

                <p><b>1. Specificeer de herinvesteringsreserve (boekwinsten) volgens openingsbalans</b></p>

                <form [formGroup]="ondernemingFG">
                    <div class="row">
                        <div formArrayName="ondernemingen">
                            <div *ngFor="let onderneming of ondernemingen.controls; let i = index "
                                 [formGroupName]="i">
                                <div>
                                    <div formArrayName="beginstandHIR">
                                        <div *ngFor="let item of getBeginstandHIR(i).controls; let k = index; "
                                             [formGroupName]="k" class="row">

                                            <snelstart-ui-text-form-control (change)="saveForm()"
                                                                            [label]="k === 0 ? 'Omschrijving boekwinsten' : ''"
                                                                            class="col-auto custom-input-250"
                                                                            formControlName="omschrijving"
                                                                            id="omschrijving"
                                            >
                                            </snelstart-ui-text-form-control>
                                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                                              [decimals]="0"
                                                                              [label]="k === 0 ? 'Bedrag' : ''"
                                                                              align="right"
                                                                              class="col-auto custom-input-150"
                                                                              formControlName="bedrag"
                                                                              id="bedrag"
                                                                              prefix="€"

                                            >
                                            </snelstart-ui-number-form-control>
                                            <snelstart-ui-button (click)="deleteBeginstandHIR(i, k)"
                                                                 [class]="k === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                                                 class="delete"
                                                                 icon="trash"
                                                                 iconType="light"
                                                                 id="buttonDelete"
                                                                 size="medium"
                                                                 type="secondary"
                                            >
                                            </snelstart-ui-button>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="getBeginstandHIR(i).length === 0">
                                    <snelstart-ui-button (click)="addBeginstandHIR(i)" class="snelstart-ui-button pb-3"
                                                         icon="plus"
                                                         id="cancelA"
                                                         type="link"> Specificatie invullen
                                    </snelstart-ui-button>
                                </div>
                                <div *ngIf="getBeginstandHIR(i).length !== 0">
                                    <snelstart-ui-button (click)="addBeginstandHIR(i)" class="snelstart-ui-button pb-3"
                                                         icon="plus"
                                                         id="cancelB"
                                                         type="link">Specificatie toevoegen
                                    </snelstart-ui-button>
                                </div>

                            </div>
                        </div>
                    </div>

                </form>
            </div>

            <div *ngIf="getTotaalBedragBeginVolgensSpec() > 0 && specBeginstandHIRFG.get('waardeOpening')?.value !== getTotaalBedragBeginVolgensSpec()"
                 class="pb-2">
                <snelstart-ui-alert type="info">
                    Het bedrag van de openingsbalans volgens bovenstaande specificatie
                    (€ {{ getTotaalBedragBeginVolgensSpec() | number:'1.0-0' }}) is (nog) niet gelijk aan het bedrag dat
                    op
                    de balans vermeld is (€ {{ specBeginstandHIRFG.get('waardeOpening')?.value | number:'1.0-0' }}).
                </snelstart-ui-alert>
            </div>

            <hr class="line-color pt-2">

            <p><b>2. Specificeer de herinvesteringsreserve (boekwinsten) volgens de slotbalans</b></p>

            <form [formGroup]="ondernemingFG">
                <div formArrayName="ondernemingen">
                    <div *ngFor="let onderneming of ondernemingen.controls; let i = index"
                         [formGroupName]="i">
                        <div formArrayName="specificatieHerinvesteringsreserve">
                            <div *ngFor="let item of getSpecHIR(i).controls; let s = index;"
                                 [formGroupName]="s" class="row">
                                <snelstart-ui-text-form-control (change)="saveForm()"
                                                                [label]="s === 0 ? 'Omschrijving bedrijfsmiddel' : ''"
                                                                class="col-auto custom-input-250"
                                                                formControlName="omschrijving"
                                                                id="omschrijving"
                                >
                                </snelstart-ui-text-form-control>
                                <snelstart-ui-select-form-control (change)="saveForm()"
                                                                  [label]="s === 0 ? 'Vervreemdingsjaar' : ''"
                                                                  [options]="jaren"
                                                                  class="col-auto custom-input-150"
                                                                  formControlName="jaarVanVervreemding"
                                                                  id="jaarVanVervreemding"
                                >
                                </snelstart-ui-select-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="s === 0 ? 'Boekwinst' : ''"
                                                                  align="right"
                                                                  class="col-auto custom-input-150"
                                                                  formControlName="boekwinst"
                                                                  id="boekwinst"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="s === 0 ? '% afschrijving' : ''"
                                                                  align="right"
                                                                  class="col-auto custom-input-150"
                                                                  formControlName="afschrijvingspercentage"
                                                                  id="afschrijvingspercentage"
                                                                  postfix="%"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-number-form-control
                                        (change)="saveForm()"
                                        [decimals]="0"
                                        [label]="s === 0 ? 'Boekwaarde bij verkoop' : ''"
                                        align="right"
                                        class="col-auto custom-input-225"
                                        formControlName="boekwaardeOpVervreemdingsmoment"
                                        id="boekwaardeOpVervreemdingsmoment"
                                        prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                                <snelstart-ui-button (click)="deleteSpecHIR(i, s)"
                                                     [class]="s === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                                     class="delete"
                                                     icon="trash"
                                                     iconType="light"
                                                     id="buttonDelete"
                                                     size="medium"
                                                     type="secondary"
                                >
                                </snelstart-ui-button>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="getSpecHIR(i).length === 0">
                                <snelstart-ui-button (click)="addSpecHIR(i)" class="snelstart-ui-button pb-3"
                                                     icon="plus"
                                                     id="cancelA"
                                                     type="link">Bedrijfsmiddel invullen
                                </snelstart-ui-button>
                            </div>
                            <div *ngIf="getSpecHIR(i).length !== 0">
                                <snelstart-ui-button (click)="addSpecHIR(i)" class="snelstart-ui-button pb-3"
                                                     icon="plus"
                                                     id="cancelB"
                                                     type="link">Bedrijfsmiddel toevoegen
                                </snelstart-ui-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div *ngIf="getTotaalBoekwinst() > 0 && specBeginstandHIRFG.get('waardeSlot')?.value !== getTotaalBoekwinst()"
                 class="pb-2">
                <snelstart-ui-alert type="info">
                    Het bedrag van de slotbalans volgens bovenstaande specificatie
                    (€ {{ getTotaalBoekwinst() | number:'1.0-0' }}) is (nog) niet gelijk aan het bedrag dat op de balans
                    vermeld is (€ {{ specBeginstandHIRFG.get('waardeSlot')?.value | number:'1.0-0' }}).
                </snelstart-ui-alert>
            </div>

        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-2" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
